module.exports = __webpack_public_path__ + "img/ayudanos.2f268761.svg";